import Vue from 'vue';
import '@/vue.js';

import PropertySearch from '@/web/appraisal/PropertySearch';
import SendAppraisal from '@/web/appraisal/components/SendAppraisal';
import GoogleMap from '@/web/appraisal/components/GoogleMap';
import EmailSuccess from '@/web/official-appraisal/components/EmailSuccess';
import ChangePropertyFeatures from '@/web/official-appraisal/components/ChangePropertyFeatures';

import axios from 'axios';

window.Vue = require('vue').default;

Vue.component('property-search', PropertySearch);
Vue.component('send-appraisal', SendAppraisal);
Vue.component('google-map', GoogleMap);
Vue.component('email-success', EmailSuccess);
Vue.component('change-property-features', ChangePropertyFeatures);

const app = new Vue({
  el: '#content',

  data() {
    return {
      emailSuccess: false,
      emailSent: false,
      changeProperty: false,
    };
  },

  methods: {
    sendOfficialAppraisalEmail() {
      if (this.emailSent) {
        this.emailSuccess = true;
        return;
      }

      axios.post(window.location.pathname + '/email').then(() => {
        this.emailSuccess = true;
        this.emailSent = true;
      });
    },

    openChangePropertyDialog() {
      this.changeProperty = true;
    },
  },
});
